/* Core & libraries */
import React, { useEffect } from "react";
import { useTheme } from "react-jss";
import { useParams } from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import { useTeamService } from "../../services/teamService";

/* Components */
import TeamDetailsHeader from "../../components/teamDetailsHeader";
import TeamDetailsTabbedNav from "../../components/teamDetailsTabbedNav";

/* Styles */
import styles from "./styles.js"



const TeamDetails = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  let { teamId } = useParams();
  const { teamDetails, getTeamDetails, editTeam, setDefaultTeam } = useTeamService();

  useEffect(() => {
    (async () => {
      await getTeamDetails(teamId)
    })();
  }, []);

  return (
    <div className={classes.teamDetails}>
      <TeamDetailsHeader teamDetails={teamDetails} editTeam={editTeam} setDefaultTeam={setDefaultTeam}/>
      <TeamDetailsTabbedNav teamDetails={teamDetails}/>
    </div>
  )
}

export default TeamDetails;
